export const ru = {
    placeholder: 'Название продукта',
    search: 'искать'
};
